import { FormControl, ValidationErrors } from '@angular/forms';

/**
 * Verifies if the imputed name is positive.
 */

const ALPHA_NUMERIC_REGEX = /^[a-zA-ZÀ-ú1-9\s]*$/;
const ALPHA_NUMERIC_VALIDATION_ERROR = { alphaNumericError: 'only alpha numeric values are allowed' };

export function alphaNumericValidator(control: FormControl): ValidationErrors | null {
    return ALPHA_NUMERIC_REGEX.test(control.value) ? undefined : ALPHA_NUMERIC_VALIDATION_ERROR;
}